import {
    SET_DETAIL_ACCOR,
    SET_DETAIL_ACCOR_DISABLED,
    SET_ARTICLE_ACCOR_TAB
} from '../../actions';

const initialState = {
    boolean: false,
    disabled: true,
    tab: 0

}

function detailAccordReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_DETAIL_ACCOR:
            newState.boolean = action.status;
            newState.disabled = state.disabled;
            newState.tab = state.tab;
            return newState;
        
        case SET_DETAIL_ACCOR_DISABLED:
            newState.boolean = state.boolean;
            newState.disabled = action.status;
            newState.tab = state.tab;
            return newState;
        
        case SET_ARTICLE_ACCOR_TAB:
            newState.boolean = state.boolean;
            newState.disabled = state.status;
            newState.tab = action.tab;
            return newState;
        
        default:
            return state;

    }
 
}

export default detailAccordReducer;
